
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCertificacionesPorRango"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fechaInicial"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fechaFinal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCertificacionesPorRango"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fechaInicial"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fechaInicial"}}},{"kind":"Argument","name":{"kind":"Name","value":"fechaFinal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fechaFinal"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cantidad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fecha_creacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"persona"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipo_doc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"num_doc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apellido"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fecha_nacimiento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telefono"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profesion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nacionalidad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estado_civil"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sexo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"educacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"localidad"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"direccion_calle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"direccion_numero"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"direccion_otro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fecha_ultimo_cambio"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tipo_certificacion"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"organismo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ciudad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"direccion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"circunscripcion"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"creador"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apellido"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":792}};
    doc.loc.source = {"body":"query getCertificacionesPorRango($fechaInicial: Date, $fechaFinal: Date){\n  getCertificacionesPorRango(fechaInicial: $fechaInicial, fechaFinal: $fechaFinal ){\n    _id\n    cantidad\n    fecha_creacion\n    persona {\n      _id,\n      tipo_doc,\n      num_doc,\n      nombre,\n      apellido,\n      fecha_nacimiento,\n      telefono,\n      profesion,\n      nacionalidad,\n      estado_civil,\n      sexo,\n      educacion,\n      localidad {\n        _id\n        nombre\n      },\n      direccion_calle\n      direccion_numero\n      direccion_otro\n      fecha_ultimo_cambio\n    }\n    tipo_certificacion {\n      _id\n      nombre\n    }\n    organismo {\n      _id\n      nombre\n      ciudad\n      direccion\n      circunscripcion\n    }\n    creador {\n      _id\n      username\n      nombre\n      apellido\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getCertificacionesPorRango"] = oneQuery(doc, "getCertificacionesPorRango");
        
